import { z } from "zod";

const CURSOR_MIN_DATE = new Date("2024-01-01T00:00:00.000Z");

export const cursorSchema = z.object({
	t: z.iso.datetime().refine((val) => {
		const d = new Date(val);
		const maxDate = new Date(Date.now() + 86_400_000);
		return d >= CURSOR_MIN_DATE && d <= maxDate;
	}),
	id: z.string(),
});

export type CursorData = z.infer<typeof cursorSchema>;
